import { DatePicker } from '@mui/x-date-pickers';
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from 'components/anexo/AnexoPanel';
import BaseDataTableEdit from 'components/dataTableableEdit/BaseDataTableEdit';
import { Label } from "components/input/Label";
import dayjs from 'dayjs';
import Usuario from 'model/administracao/cadastro/Usuario';
import ItemInspecaoFrota from 'model/gestao/frotas/ItemInspecaoFrota';
import MarcaVeiculo from 'model/gestao/frotas/MarcaVeiculo';
import UsuarioVeiculo from 'model/gestao/frotas/UsuarioVeiculo';
import Veiculo from 'model/gestao/frotas/Veiculo';
import VeiculoItemInspecao from 'model/gestao/frotas/VeiculoItemInspecao';
import { AutoComplete } from 'primereact/autocomplete';
import { Checkbox } from 'primereact/checkbox';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { useEffect, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import UsuarioService from 'service/administracao/cadastro/UsuarioService';
import VeiculoService from 'service/gestao/frotas/VeiculoService';
import { converterData, converterDataHora, removerAcento } from 'utils/convert';

const veiculoService = new VeiculoService();
export default function VeiculoCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [veiculo, setVeiculo] = useState<Veiculo>(new Veiculo());
    const [titulo, setTitulo] = useState<string>('Veículo');
    const [marcasDisponiveis, setMarcasDisponiveis] = useState<MarcaVeiculo[]>([]);
    const [itensInspecaoDisponiveis, setItensInspecaoDisponiveis] = useState<ItemInspecaoFrota[]>([]);
    const [itensInspecaoFiltrados, setItensInspecaoFiltrados] = useState<ItemInspecaoFrota[]>([]);
    const [veiculoItemInspecao, setVeiculoItemInspecao] = useState<ItemInspecaoFrota>(new ItemInspecaoFrota());

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);

    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);
    const [novosAnexos, setNovosAnexos] = useState([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        veiculoService.marcasDisponiveis().then((data) => {
            setMarcasDisponiveis(data);
        }).catch((error) => {
            msgErro('Erro', 'Erro ao buscar marcas disponíveis');
        });
        veiculoService.itensInspecaoDisponiveis().then((data) => {
            setItensInspecaoDisponiveis(data);
        }).catch((error) => {
            msgErro('Erro', 'Erro ao buscar itens de inspeção disponíveis');
        });
        veiculoService.usuariosDisponiveis().then((data) => {
            setUsuarios(data);
        }).catch((error) => {
            msgErro('Erro', 'Erro ao buscar usuários disponíveis');
        });
    }, [])

    function validar() {
        if (!veiculo.identificador) {
            setError("identificador", { type: "manual", message: "Identificador é Obrigatório" }, { shouldFocus: true })
            msgAlerta('Identificador', 'Identificador é obrigatório');
            return false;
        }
        if (!veiculo.marca || !veiculo.marca.id) {
            setError("marca", { type: "manual", message: "Marca é Obrigatória" }, { shouldFocus: true })
            msgAlerta('Marca', 'Marca é obrigatório');
            return false;
        }
        if (!veiculo.modelo) {
            setError("modelo", { type: "manual", message: "Modelo é Obrigatório" }, { shouldFocus: true })
            msgAlerta('Modelo', 'Modelo é obrigatório');
            return false;
        }

        for (let i = 0; veiculo.itensInspecao.length > i; i++) {
            if (veiculo.itensInspecao[i].itemInspecao == null || !veiculo.itensInspecao[i].itemInspecao.id) {
                msgAlerta('Item de Inspeção', 'Item de Inspeção não informado corretamente no item ' + (i + 1));
                return false;
            }

            if (veiculoItemInspecao.periodicidade == null) {
                msgAlerta('Periodicidade', 'Periodicidade é obrigatória');
                return false;
            }
        }


        return true;
    }

    const editorUsuario = (options: ColumnEditorOptions) => {
        return <Dropdown
            className="col col-sm-12"
            options={usuarios}
            filter
            dataKey="id"
            optionLabel="nome"
            valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
            value={options.rowData.usuario}
            style={{ width: '100%' }}
            onChange={(e) => {
                if (e.value.id === -1) {
                    veiculo.usuariosVeiculo[options.rowIndex].usuario = null;
                    options.rowData.usuario = null;
                }
                else {
                    veiculo.usuariosVeiculo[options.rowIndex].usuario = e.value as Usuario;
                    options.rowData.usuario = e.value as Usuario;
                }
                setVeiculo({ ...veiculo })
            }}
        />
    }

    const editorVeiculoPadraoDoUsuario = (options: ColumnEditorOptions) => {
        return <Checkbox checked={options.rowData.veiculoPadraoDoUsuario} onChange={(e) => {
            veiculo.usuariosVeiculo[options.rowIndex].veiculoPadraoDoUsuario = e.checked || false;
            options.rowData.veiculoPadraoDoUsuario = e.checked;
            setVeiculo({ ...veiculo })
        }} style={{ display: 'block', margin: '0 auto' }} />
    }

    const editorItemInspecao = (options: any) => {
        return (
            <AutoComplete
                suggestions={itensInspecaoFiltrados}
                placeholder="Selecione um Item"
                inputStyle={{ width: '100%' }}
                field='nome'
                value={options.rowData.itemInspecao}
                onChange={(e) => {
                    if (typeof e.target.value === 'string') {
                        let item = new ItemInspecaoFrota();
                        item.nome = e.target.value;

                        options.rowData['itemInspecao'] = item;
                        options.rowData.intervaloDiasRevisao = 0;
                        options.rowData.intervaloHorasRevisao = 0;
                        options.rowData.intervaloQuilometragemRevisao = 0;

                    } else {
                        options.rowData['itemInspecao'] = e.target.value;
                        options.rowData.intervaloDiasRevisao = e.target.value.intervaloDiasRevisao;
                        options.rowData.intervaloHorasRevisao = e.target.value.intervaloHorasRevisao;
                        options.rowData.intervaloQuilometragemRevisao = e.target.value.intervaloQuilometragemRevisao;

                    }

                    let veiculoLocal = { ...veiculo };
                    veiculoLocal.itensInspecao[options.rowIndex] = options.rowData;
                    setVeiculo(veiculoLocal);
                }}

                completeMethod={(e) => {
                    setItensInspecaoFiltrados(itensInspecaoDisponiveis.filter((item) => removerAcento(item.nome.toLowerCase()).startsWith(removerAcento(e.query.toLowerCase()))));
                }}
                style={{ width: '100%' }}
            />
        );
    }

    const editorDescricao = (options: ColumnEditorOptions) => {
        return <InputTextarea value={options.rowData.descricao} maxLength={200} onChange={(e) => onChangeItem(options, e.target.value)} style={{ width: '100%' }} />
    }

    const editorIntervaloHoras = (options: ColumnEditorOptions) => {
        return <InputNumber value={options.rowData.intervaloHorasRevisao}
            onChange={(e) => onChangeItem(options, e.value)} style={{ width: '100%' }} inputStyle={{ width: '100%' }}
            locale='pt-BR' useGrouping={false} minFractionDigits={0} maxFractionDigits={2} maxLength={10}
        />
    }

    const editorIntervaloQuilometragem = (options: ColumnEditorOptions) => {
        return <InputNumber value={options.rowData.intervaloQuilometragemRevisao}
            onChange={(e) => onChangeItem(options, e.value)} style={{ width: '100%' }} inputStyle={{ width: '100%' }}
            locale='pt-BR' useGrouping={false} minFractionDigits={0} maxFractionDigits={2} maxLength={12}
        />
    }

    const editorValorPeriodicidade = (options: ColumnEditorOptions) => {
        return <InputNumber value={options.rowData.vlPeriodicidadeRevisao}
            onChange={(e) => onChangeItem(options, e.value)} style={{ width: '100%' }} inputStyle={{ width: '100%' }}
            locale='pt-BR' useGrouping={false} minFractionDigits={0} maxFractionDigits={0} maxLength={10}
        />
    }

    const editorPeriodicidade = (options: ColumnEditorOptions) => {
        return <Dropdown value={options.rowData.periodicidade} options={[{ label: 'Dias', value: 'DIAS' }, { label: 'Meses', value: 'MESES' }, { label: 'Anos', value: 'ANOS' }]} optionLabel="label" onChange={(e) => {
            options.rowData['periodicidade'] = e.value;
            let veiculoLocal = { ...veiculo };
            veiculo.itensInspecao[options.rowIndex] = options.rowData;
            setVeiculo(veiculoLocal);
        }} style={{ width: '100%' }} />
    }

    const editorHorimetroUltimaInspecao = (options: ColumnEditorOptions) => {
        return <InputNumber value={options.rowData.horimetroUltimaInspecao}
            onChange={(e) => onChangeItem(options, e.value)} style={{ width: '100%' }} inputStyle={{ width: '100%' }}
            locale='pt-BR' useGrouping={false} minFractionDigits={0} maxFractionDigits={2} maxLength={10}
        />
    }

    const editorQuilometragemUltimaInspecao = (options: ColumnEditorOptions) => {
        return <InputNumber value={options.rowData.quilometragemUltimaInspecao}
            onChange={(e) => onChangeItem(options, e.value)} style={{ width: '100%' }} inputStyle={{ width: '100%' }}
            locale='pt-BR' useGrouping={false} minFractionDigits={0} maxFractionDigits={2} maxLength={12}
        />
    }

    const editorDataUltimaInspecao = (options: ColumnEditorOptions) => {
        return <DatePicker
            value={dayjs(options.rowData.dataUltimaInspecao)}
            onChange={value => onChangeItem(options, value?.toDate() || null)}
        />
    }

    const onChangeItem = (options: ColumnEditorOptions, value: any) => {
        options.rowData[options.field] = value;
        let veiculoLocal = { ...veiculo };
        veiculoLocal.itensInspecao[options.rowIndex] = options.rowData;
        setVeiculo(veiculoLocal);
    }

    function onSave() {
        setNovosAnexos([]);
    }

    return (

        <BaseCadastro model={veiculo} service={veiculoService}
            onSave={() => onSave()}
            getModel={() => {
                const data = getFormData('veiculo', veiculo, novosAnexos);
                return data;
            }} novoCadastro
            setModel={(value: Veiculo) => setVeiculo(value)} getNewModel={() => new Veiculo()} validar={() => validar()} urlService="/veiculo" pathCadastro="/veiculo" tituloPagina={'Veiculo'}
        >

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Identificador</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.identificador ? "p-invalid" : ""}
                        value={veiculo.identificador}
                        maxLength={10}
                        style={{ width: '100%' }}
                        {...register("identificador", {
                            onChange: (e) => {
                                setVeiculo({ ...veiculo, identificador: e.target.value })
                                clearErrors("identificador")
                            }
                        })}
                    />
                </div>
                {errors.identificador && errors.identificador.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.identificador?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Marca</Label>
                <div className="col-sm-12">
                    <Controller name="marca" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            options={marcasDisponiveis}
                            className={errors.marca ? "p-invalid" : ""}
                            optionLabel='nome'
                            value={veiculo.marca}
                            onChange={(e) => {
                                setVeiculo({ ...veiculo, marca: e.target.value })
                                clearErrors("marca")
                            }}
                            style={{ width: '100%' }}
                        />
                    )} />
                </div>
                {errors.marca && errors.marca.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.marca?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Modelo</Label>
                <div className="col-sm-12">
                    <InputText
                        value={veiculo.modelo}
                        className={errors.modelo ? "p-invalid" : ""}
                        maxLength={50}
                        style={{ width: '30%' }}
                        {...register("modelo", {
                            onChange: (e) => {
                                setVeiculo({ ...veiculo, modelo: e.target.value })
                                clearErrors("modelo")
                            }
                        })}
                    />
                </div>
                {errors.modelo && errors.modelo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.modelo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Placa</Label>
                <div className="col-sm-12">
                    <InputText value={veiculo.placa} onChange={(e) => setVeiculo({ ...veiculo, placa: e.target.value })}
                        maxLength={12}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Renavam</Label>
                <div className="col-sm-12">
                    <InputNumber
                        value={veiculo.renavam} onChange={(e) => setVeiculo({ ...veiculo, renavam: e.value })}
                        locale='pt-BR' useGrouping={false}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Chassi</Label>
                <div className="col-sm-12">
                    <InputText value={veiculo.chassi as string}
                        onChange={(e) => setVeiculo({ ...veiculo, chassi: e.target.value })}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Horimetro</Label>
                <div className="col-sm-12">
                    <InputNumber value={veiculo.horimetro} onChange={(e) => setVeiculo({ ...veiculo, horimetro: e.value })}
                        style={{ width: '30%' }}
                        minFractionDigits={0}
                        maxFractionDigits={2}
                        maxLength={10}
                        locale='pt-BR' useGrouping={false}
                    />
                </div>
            </div>

            <div className="row">
                <div style={{ width: "30%", padding: 0 }}>
                    <Label className="col col-sm-12">Quilometragem</Label>
                    <div className="col-sm-12">
                        <InputNumber value={veiculo.quilometragem} onChange={(e) => setVeiculo({ ...veiculo, quilometragem: e.value })}
                            style={{ width: '100%' }}
                            minFractionDigits={0}
                            maxFractionDigits={2}
                            maxLength={12}
                            locale='pt-BR' useGrouping={false}
                        />
                    </div>
                </div>
                <div style={{ width: "20%" }}>
                    <Label className="col col-sm-12">Última atualização</Label>
                    <div className="col-sm-12">
                        <InputText disabled value={veiculo.dataAtualizacaoKm ? converterDataHora(veiculo.dataAtualizacaoKm) : ""} style={{ width: "100%" }} />
                    </div>
                </div>

            </div>

            <div className="row">
                <Label className="col col-sm-12">Código Sisatec</Label>
                <div className="col-sm-12">
                    <InputNumber value={veiculo.codigoSisatec}
                        onChange={(e) => setVeiculo({ ...veiculo, codigoSisatec: e.value })}
                        style={{ width: '30%' }}
                        useGrouping={false}
                        locale='pt-BR'
                        maxFractionDigits={0}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <AnexoPanel
                        novosAnexos={novosAnexos} onChangeNovosAnexos={(e: any) => setNovosAnexos(e)}
                        arquivos={veiculo.arquivos} onChange={(e) => {
                            setVeiculo({ ...veiculo, arquivos: e })
                        }}
                        collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Usuários"
                        getNewModel={() => new UsuarioVeiculo()}
                        dataKey="key"
                        lista={veiculo.usuariosVeiculo ? veiculo.usuariosVeiculo : []}
                        setLista={(value: any) => setVeiculo({ ...veiculo, usuariosVeiculo: value })}
                        scrollable
                        scrollHeight='500px'
                    >
                        <Column
                            field="usuario" header="Usuário"
                            style={{ width: '65%' }}
                            body={(rowData: UsuarioVeiculo) => rowData.usuario ? rowData.usuario.nome : "Selecione"}
                            editor={editorUsuario}
                        />
                        <Column
                            body={(rowData: UsuarioVeiculo) => <Checkbox checked={rowData.veiculoPadraoDoUsuario} />}
                            header="Veículo Padrão do Usuário"
                            style={{ width: '20%', textAlign: 'center' }}
                            editor={editorVeiculoPadraoDoUsuario}
                        />
                    </BaseDataTableEdit>
                </div>
            </div>


            <div className="row">
                <div className="col col-sm-12 mt-2">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new VeiculoItemInspecao()}
                        dataKey="key"
                        lista={veiculo ? veiculo.itensInspecao : []}
                        setLista={(value: VeiculoItemInspecao[]) => {
                            setVeiculo({ ...veiculo, itensInspecao: value });
                        }}
                        scrollHeight="500px"
                        scrollable={true}
                        reordable={true}
                        onRowReorder={(e) => {
                            let veiculoLocal = { ...veiculo };
                            let itens = e.value.map((item, index) => {
                                return {
                                    ...item,
                                    sequencial: index + 1,
                                }
                            })
                            veiculoLocal.itensInspecao = itens as VeiculoItemInspecao[];

                            setVeiculo(veiculoLocal);
                        }}
                    >
                        <Column rowReorder style={{ width: '4%' }}></Column>
                        <Column field="itemInspecao.nome" header="Item Inspeção" style={{ width: '20%', fontSize: '10pt' }} editor={(options) => editorItemInspecao(options)}></Column>
                        <Column field='descricao' header='Descrição' style={{ width: '20%', fontSize: '10pt' }} editor={(options) => editorDescricao(options)}></Column>
                        <Column field="vlPeriodicidadeRevisao" header="Valor Periodicidade" style={{ width: '6%', fontSize: '10pt' }} editor={(options) => editorValorPeriodicidade(options)}></Column>
                        <Column
                            field="periodicidade" header="Periodicidade" style={{ width: '6%', fontSize: '10pt' }} editor={(options) => editorPeriodicidade(options)}
                            body={rowData => veiculoService.getPeriodicidade(rowData.periodicidade)}
                        ></Column>
                        <Column field="intervaloQuilometragemRevisao" header="Intervalo Km." style={{ width: '6%', fontSize: '10pt' }} editor={(options) => editorIntervaloQuilometragem(options)}></Column>
                        <Column field="intervaloHorasRevisao" header="Intervalo Horas" style={{ width: '6%', fontSize: '10pt' }} editor={(options) => editorIntervaloHoras(options)}></Column>
                        <Column field="dataUltimaInspecao" body={(rowData) => rowData.dataUltimaInspecao ? converterData(rowData.dataUltimaInspecao) : ""} header="Data Ultima Inspeção" style={{ width: '20%', fontSize: '10pt' }} editor={(options) => editorDataUltimaInspecao(options)}></Column>
                        <Column field="quilometragemUltimaInspecao" header="Km. Ultima Inspeção" style={{ width: '8%', fontSize: '10pt' }} editor={(options) => editorQuilometragemUltimaInspecao(options)}></Column>
                        <Column field="horimetroUltimaInspecao" header="Horimetro Ultima Inspeção" style={{ width: '10%', fontSize: '10pt' }} editor={(options) => editorHorimetroUltimaInspecao(options)}></Column>
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}
